import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Main Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}>
        <div className="container-custom">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img 
                src="/img/LogoSolnascente.png" 
                alt="Sol Nascente Hortaliças" 
                className="h-12 w-auto"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
              <div className="text-primary-800">
                <h1 className="text-xl font-bold">Sol Nascente</h1>
                <p className="text-sm text-primary-600">Hortaliças</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Nossos Produtos
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Galeria de Produtos
              </button>
              <button 
                onClick={() => scrollToSection('locations')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Lojas
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium"
              >
                Contato
              </button>
              <a 
                href="https://wa.me/551532415413" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
              >
                WhatsApp
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-primary-800 p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-primary-100 shadow-lg">
            <div className="px-4 pt-2 pb-6 space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Nossos Produtos
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Galeria de Produtos
              </button>
              <button 
                onClick={() => scrollToSection('locations')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Lojas
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left text-primary-700 hover:text-primary-800 transition-colors duration-200 font-medium py-2"
              >
                Contato
              </button>
              <div className="pt-4 border-t border-primary-100">
                <a 
                  href="https://wa.me/551532415413" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 block text-center"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Header;
